import {
  BodyText,
  Button,
  Flex,
  MailIcon,
  PhoneIcon,
  Title,
  mq,
  theme
} from '@kvdbil/components';
import { Maybe } from 'graphql/jsutils/Maybe';
import React from 'react';
import styled from 'styled-components';
import Link from '~/App/shared/components/Link';
import { ContactSectionRecord } from '~/config/generated/graphql';

const Container = styled.div`
  background-color: ${theme.colors.background.light};
  padding: 2rem 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${mq(null, 'tablet')} {
    flex-direction: column;
  }
`;

const TextContainer = styled.div`
  text-align: center;
`;

const Buttons = styled(Flex)`
  width: 100%;
  max-width: 343px;

  margin: 0 2rem;
  ${mq(null, 'tablet')} {
    margin: 2rem auto;
  }
`;

const IconSwitch = ({ icon }: { icon: Maybe<string> | undefined }) => {
  switch (icon) {
    case 'PhoneIcon':
      return <PhoneIcon />;
    case 'MailIcon':
    default:
      return <MailIcon />;
  }
};

function Contact({
  title,
  subtitle,
  days,
  extraInfo,
  buttons
}: ContactSectionRecord) {
  return (
    <Container>
      <TextContainer>
        <Title>{title}</Title>
        <BodyText>{subtitle}</BodyText>
      </TextContainer>
      <Buttons direction={'column'}>
        {buttons.map(button => {
          return (
            <Link key={button.text} to={button.href ?? ''}>
              <Button
                as="div"
                color="info"
                colorShade="dark"
                variant="outline"
                size="large"
                prefixIcon={<IconSwitch icon={button.icon} />}
                style={{ justifyContent: 'center' }}
              >
                {button.text}
              </Button>
            </Link>
          );
        })}
      </Buttons>

      <Flex direction={'column'} gap={0}>
        <BodyText>{days}</BodyText>
        {extraInfo && <BodyText>{extraInfo}</BodyText>}
      </Flex>
    </Container>
  );
}

export default Contact;
